@use "~@frontrow/console/css/variables.scss";

.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.dialog {
  position: fixed;
  inset: 0;
  margin: auto;
  width: 660px;
  height: fit-content;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  z-index: 1050;
}

.dialogSm {
  width: 400px;
}

.dialogLg {
  width: 940px;
  max-width: calc(100vw - 3rem);
}

.header {
  padding: variables.$std-padding-md variables.$std-padding-md
    variables.$std-padding-sm variables.$std-padding-md;
  border-bottom: 1px solid variables.$gray-light-2;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-family: system-ui, sans-serif;
  font-size: 24px;
  padding: 0;
  margin: 0;
  color: variables.$gray-dark-2;
}

.body {
  padding: variables.$std-margin-md;
  max-height: 70vh;
  overflow-y: auto;
}

.footer {
  padding: variables.$std-margin-md;
  display: flex;
  justify-content: flex-end;
  gap: variables.$std-margin-xs;
}

.closeButton {
  appearance: none;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  color: variables.$gray-dark-2;
}
